import { ReactElement } from 'react';

import styled from 'styled-components';

import { IconFancyContainerProps } from '@components/icon-fancy-container';
import { IconProps } from '@components/icons';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type EventConfig = {
  icon: ReactElement<IconProps>;
  variant: NonNullable<IconFancyContainerProps['variant']>;
};

export const ICON_SIZE = 16;

export const IconColumn = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexShrink: 0,
});

export const ConnectorLine = styled.div({
  width: pxToRem(2),
  flex: 1,
  minHeight: pxToRem(16),
  backgroundColor: theme.color.border10,
});

export const ContentColumn = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: pxToRem(2),
  paddingBottom: pxToRem(16),
  flex: 1,
});

export const PerformedByRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: pxToRem(6),
  marginTop: pxToRem(2),
});
